import { useEffect, useState } from "react";
import { LoaderBoxCircular } from "../Components/LoaderBox";
import { Box, Container, TextField, Grid, Divider, Typography, Button, Alert } from "@mui/material";
import { DropDownList } from "../Components/DropDownList";
import { ArrowBack, EditTwoTone } from "@mui/icons-material";
import { DialogAlert } from "../Components/DialogAlert";
import { instance } from "../Components/config";
import { useNavigate } from "react-router-dom";

import { useAuth } from "../Components/AuthContext";
import { UPSE8DetalleProducto } from "../Components/UPSE8DetalleProducto";
import { InstruccionesModal } from "../Components/InstruccionesModal";

function UPSE8Agregar() {
  const { user } = useAuth();
  const navigate = useNavigate();

  const [idUpse2, setIdUpse2] = useState({ Id: "", Nombre: "" });
  const [anio, setAnio] = useState(0);
  const [tipoPlanificacion, setTipoPlanificacion] = useState("");
  const [encargado, setEncargado] = useState({ Id: "", Nombre: "" });
  const [responsable] = useState({ Id: user.id, Nombre: user.nombre + " " + user.apellido });
  const [techoPresupuestario, setTechoPresupuestario] = useState(0);

  const [ventana, setVentana] = useState({ configurado: false, dentroDeVentana: true, bloqueado: false });
  const [justificacionFueraVentana, setJustificacionFueraVentana] = useState("");

  const [productoSeleccionado, setProductoSeleccionado] = useState(null);
  const [indexEdicion, setIndexEdicion] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingProductos, setIsLoadingProductos] = useState(false);
  const [openForm, setOpenForm] = useState(false);

  const [listaDetalle, setListaDetalle] = useState([]);

  const [openDialog, setOpenDialog] = useState(false);
  const [dialog, setDialog] = useState({
    title: "",
    text: "",
    redirect: false,
    page: "/UPSE8",
    pageState: {}
  });

  useEffect(() => {
    if (idUpse2.Id === "") {
      setAnio(0);
      setTipoPlanificacion("");
      setListaDetalle([]);
      return;
    }

    instance.get(`/upse2/listById/${idUpse2.Id}`)
      .then((res) => {
        setAnio(res.data.anioMeta || 0);
        setTipoPlanificacion(res.data.tipoPlanificacion || "");
        setTechoPresupuestario(res.data.techo || 0);
      })
      .catch(() => { });

  }, [idUpse2.Id]);

  useEffect(() => {
    if (idUpse2.Id === "" || tipoPlanificacion === "") {
      return;
    }
    const esSemillas = tipoPlanificacion === "semillas";
    const endpoint = esSemillas
      ? `/upse8/cultivaresConMeta/${idUpse2.Id}`
      : `/upse8/productosConMeta/${idUpse2.Id}`;

    setIsLoadingProductos(true);
    instance.get(endpoint)
      .then((res) => {
        setListaDetalle(res.data.map((item) => ({ ...item, reprogramacion: null })));
      })
      .catch(() => { setListaDetalle([]); })
      .finally(() => setIsLoadingProductos(false));
  }, [idUpse2.Id, tipoPlanificacion]);

  useEffect(() => {
    if (!anio) {
      setVentana({ configurado: false, dentroDeVentana: true, bloqueado: false });
      return;
    }
    instance.get(`/upse8/validarVentana/${anio}`)
      .then((res) => setVentana(res.data))
      .catch(() => setVentana({ configurado: false, dentroDeVentana: true, bloqueado: false }));
  }, [anio]);

  const handleReprogramar = (producto, index) => {
    setProductoSeleccionado(producto);
    setIndexEdicion(index);
    setOpenForm(true);
  }

  const handleClose = () => {
    setOpenForm(false);
    setIndexEdicion(null);
    setProductoSeleccionado(null);
  }

  const handleSubmit = (payload) => {
    const copia = [...listaDetalle];
    copia[indexEdicion]['reprogramacion'] = payload;
    setListaDetalle(copia);
    setIndexEdicion(null);
    setProductoSeleccionado(null);
  }

  const envioFormulario = (e) => {
    e.preventDefault();

    const reprogramados = listaDetalle.filter((item) => item.reprogramacion);
    if (reprogramados.length === 0) {
      setDialog({
        title: 'Aviso',
        text: 'Debe reprogramar al menos un producto antes de enviar el formulario'
      })
      setOpenDialog(true);
      return;
    }

    if (!ventana.dentroDeVentana && !justificacionFueraVentana.trim()) {
      setDialog({
        title: 'Falta información',
        text: 'Estás fuera de las ventanas oficiales de presentación. Debes indicar la justificación por presentación fuera de fecha.'
      })
      setOpenDialog(true);
      return;
    }

    setIsLoading(true);
    const payload = {
      idUpse2,
      anioMeta: anio,
      tipoPlanificacion,
      encargado,
      techoPresupuestario: Number(techoPresupuestario),
      fueraDeVentana: !ventana.dentroDeVentana,
      justificacionFueraVentana: !ventana.dentroDeVentana ? justificacionFueraVentana : null,
      listaDetalle: reprogramados.map((item) => item.reprogramacion),
      idCrea: user.id
    }

    instance.post('/upse8/crear', payload)
      .then(() => {
        setDialog({
          title: 'Aviso',
          text: 'Se ha creado correctamente el formulario',
          redirect: true,
          page: '/UPSE8'
        })
      })
      .catch((err) => {
        if (err.response?.status === 500) {
          setDialog({
            title: "ERROR",
            text: "Existe algún problema con el servidor, por favor inténtalo de nuevo mas tarde, si el problema persiste contáctate con alguno de los encargados.",
          });
        } else {
          setDialog({ title: "ERROR", text: err.response?.data?.mensaje });
        }
      }).finally(() => {
        setIsLoading(false);
        setOpenDialog(true);
      })
  }

  const esSemillas = tipoPlanificacion === "semillas";

  return (
    <Container>
      <Box sx={{ marginTop: 4, display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
        <Button startIcon={<ArrowBack />} onClick={() => navigate(-1)}>Volver</Button>
        <h2 style={{ textAlign: 'center', flex: 1, margin: 0 }}>Reprogramación de metas físicas UPSE-8</h2>
        <InstruccionesModal clave="UPSE8" />
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
        <LoaderBoxCircular isLoading={isLoading}>
          <Container maxWidth="lg" sx={{ marginBottom: 5 }}>
            <Box
              sx={{
                padding: "4px",
                margin: { xs: 0, sm: 1 },
                border: { xs: "0", sm: "1px solid #000" },
              }}
              component="form"
              onSubmit={envioFormulario}
            >
              <Grid
                container
                spacing={3}
                padding={2}
                rowSpacing={1}
                sx={{ alignItems: "center" }}
              >
                <Grid item xs={12} sm={12}>
                  <h3 style={{ textAlign: 'center', margin: 0 }}>Datos generales</h3>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <p>Selecciona UPSE 2</p>
                  <DropDownList
                    required
                    title="Seleccione UPSE2"
                    endpoint={"/upse4/upse2Aprobados?id=" + user.id}
                    selectedItem={idUpse2}
                    setSelectedItem={setIdUpse2}
                  />
                </Grid>

                <Grid item xs={12} sm={3} marginTop={5}>
                  <TextField
                    required
                    disabled
                    label="Año"
                    type="number"
                    fullWidth
                    value={anio}
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>

                <Grid item xs={12} sm={3} marginTop={5}>
                  <TextField
                    fullWidth
                    label="Techo presupuestario"
                    type="number"
                    value={techoPresupuestario}
                    onChange={(e) => setTechoPresupuestario(e.target.value)}
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>

                <Grid item xs={12} sm={6} marginTop={4}>
                  <TextField
                    margin="normal"
                    required
                    fullWidth
                    label="Responsable"
                    disabled
                    value={responsable.Nombre}
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <p>Jefe inmediato / encargado de revisión</p>
                  <DropDownList
                    required
                    title="Seleccione encargado"
                    endpoint={"/users/listActive"}
                    selectedItem={encargado}
                    setSelectedItem={setEncargado}
                  />
                </Grid>

                {ventana.bloqueado && (
                  <Grid item xs={12}>
                    <Alert severity="error">
                      Ya pasó la fecha límite configurada para presentar reprogramaciones en el año {anio}. No es posible crear un nuevo formulario.
                    </Alert>
                  </Grid>
                )}

                {!ventana.bloqueado && !ventana.dentroDeVentana && anio > 0 && (
                  <>
                    <Grid item xs={12}>
                      <Alert severity="warning">
                        Estás presentando esta reprogramación fuera de las ventanas oficiales de presentación. Debes justificar el motivo.
                      </Alert>
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        required
                        fullWidth
                        multiline
                        rows={2}
                        label="Justificación por presentación fuera de fecha"
                        value={justificacionFueraVentana}
                        onChange={(e) => setJustificacionFueraVentana(e.target.value)}
                        InputLabelProps={{ shrink: true }}
                      />
                    </Grid>
                  </>
                )}

                <Grid item xs={12} sm={12} marginTop={2}>
                  <Divider variant="middle" component="aside" />
                </Grid>

                <Grid item xs={12}>
                  <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center' }}>
                    {esSemillas ? "Selecciona los cultivares que deseas reprogramar" : "Selecciona los productos que deseas reprogramar"}
                  </Typography>
                </Grid>
                <Grid item sm={2}></Grid>
                <Grid xs={12} sm={8}>
                  <LoaderBoxCircular isLoading={isLoadingProductos} />
                  {listaDetalle.map((detalle, index) => (
                        <Box
                          key={index}
                          sx={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            gap: 2,
                            border: "1px solid #ccc",
                            borderRadius: 1,
                            padding: 2,
                            marginBottom: 1,
                            marginTop: 2,
                            boxShadow: 1
                          }}
                        >
                          <Box sx={{ flex: '1 1 260px', minWidth: 0 }}>
                            <Typography variant="subtitle1" fontWeight="bold">
                              {detalle.detalle}
                            </Typography>
                            <Typography variant="body2">
                              {detalle.departamento} · {detalle.municipio} · {detalle.localidad}
                            </Typography>
                            <Typography variant="body2">
                              Meta anual vigente: {detalle.metaInicial}
                              {detalle.reprogramacion && ` → Meta modificada: ${detalle.reprogramacion.metaModificadaFinal}`}
                            </Typography>
                          </Box>
                          <Box sx={{ display: 'flex', gap: 1, flexShrink: 0, flexWrap: 'wrap' }}>
                            <Button
                              variant={detalle.reprogramacion ? "contained" : "outlined"}
                              color={detalle.reprogramacion ? "success" : "primary"}
                              startIcon={<EditTwoTone />}
                              onClick={() => handleReprogramar(detalle, index)}
                            >
                              {detalle.reprogramacion ? "Reprogramado" : "Reprogramar"}
                            </Button>
                          </Box>
                        </Box>
                  ))}
                </Grid>
                <Grid item sm={2}></Grid>

                <Grid item sm={4} />
                <Grid item xs={12} sm={4}>
                  <Button fullWidth variant="contained" type="submit" disabled={ventana.bloqueado}>Enviar</Button>
                </Grid>
                <Grid item sm={4} />
              </Grid>
            </Box>
          </Container>
        </LoaderBoxCircular>
        <UPSE8DetalleProducto
          open={openForm}
          onClose={handleClose}
          onSubmit={handleSubmit}
          producto={productoSeleccionado}
          esSemillas={esSemillas}
        />
        <DialogAlert
          title={dialog.title}
          text={dialog.text}
          open={openDialog}
          setOpen={setOpenDialog}
          redirectOnClose={dialog.redirect}
          page={dialog.page}
          pageState={dialog.pageState}
        />
      </Box>
    </Container>
  );
}

export { UPSE8Agregar };
